<template>
	<ul class="nav nav-pills flex-column mt-3">
		<button class="nav-link gap-3 rounded-0 rounded-start rounded-pill d-flex align-items-center" :class="this.menu.active == 'home' ? 'active' : ''" style="height:45px;" @click="selected('home')">
			<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" class="bi bi-person-circle text-center" viewBox="0 0 16 16">
				<path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
				<path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
			</svg>
			Home
		</button>
		<button class="nav-link gap-3 rounded-0 rounded-start rounded-pill d-flex align-items-center" :class="this.menu.active == 'basic' ? 'active' : ''" style="height:45px;" @click="selected('basic')">
			<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" class="bi bi-person-lines-fill" viewBox="0 0 16 16">
				<path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z"/>
			</svg>
			Personal info
		</button>
	</ul>
</template>
<script>
	import { router } from "@/router/index.js";
    import { $global } from "@/dot-ui/index.js";
	
	export default 
	{
		data()
		{
			return {
				menu: {
					active: "",
				},
                fromParams: "",
			}
		},
        created() 
        {
            this.fromParams = $global.getUrlParams();
        },
		mounted() {
            
        },
		methods: 
        {
			selected(value)
			{
				if ("home" === value) {
					this.menu.active = "home";
					router.push({
                        path : "/",
                        query: {
                            cb: this.fromParams.cb,
                            s: this.fromParams.s,
                            c: this.fromParams.c,
                        }
                    });
				}
				if ("basic" === value) {
					this.menu.active = "basic";
					router.push({
                        path : "/basic",
                        query: {
                            cb: this.fromParams.cb,
                            s: this.fromParams.s,
                            c: this.fromParams.c,
                        }
                    });
				}
			},
		},
	}
</script>
<style>
</style>
